import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/permission';

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title == undefined ? process.env.VUE_APP_LOGO_NAME : to.meta.title + ' - ' + process.env.VUE_APP_LOGO_NAME;
  next();
});

Vue.config.productionTip = false;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Basic from '@/components/index'; // 引入基础组件
import http from '@/utils/http'; //封装接口

Vue.use(ElementUI);
Vue.use(Basic);
Vue.prototype.$http = http;

window.$vue = new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
